import styled from '@emotion/styled';
import { TRACKER_MESSAGE_TRANSPORT, type TRACKER_TYPES } from '@racemap/sdk/schema/trackers';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Flex } from 'antd';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import type { ManagedTracker } from '../../../store/trackers/trackers_reducers';
import { IconExclamationTriangle } from '../../Icon';
import { Center, HStack } from '../MetaComponent';

export interface Props {
  total: number;
  targetTrackers: Immutable<Array<ManagedTracker>>;
  transport: TRACKER_MESSAGE_TRANSPORT;
}

export const TrackerTargetCount: FC<Props> = ({ total, targetTrackers, transport }) => {
  if (targetTrackers.length === 0) return null;
  const title = getTitleText(targetTrackers, transport);

  if (targetTrackers.length === total) {
    return (
      <Container>
        <Count>{targetTrackers.length}</Count> trackers targeted
      </Container>
    );
  }

  return (
    <Container title={title}>
      <HStack gap="4px">
        <IconExclamationTriangle />
        <Flex>
          <Count>{targetTrackers.length}</Count> of <Count>{total}</Count> trackers targeted
        </Flex>
      </HStack>
    </Container>
  );
};

function getTitleText(
  targetTrackers: Immutable<Array<ManagedTracker>>,
  transport: TRACKER_MESSAGE_TRANSPORT,
): string {
  if (targetTrackers.length === 0) return 'No trackers targeted';
  if (transport === TRACKER_MESSAGE_TRANSPORT.SMS) return 'Targeting only SMS capable trackers';

  const types = new Set<TRACKER_TYPES>(targetTrackers.map((t) => t.trackerType));

  return `Targeting only activ trackers and of valid type for selected command:
  ${Array.from(types)
    .map((t) => t)
    .join('\n')}`;
}

const Container = styled(Center)`
  background-color: ${RacemapColors.LightBlue};
  padding: 7px 17px;
  border-radius: 1.25rem;

`;

const Count = styled.div`
  font-weight: 700;
  margin: 0 3px;
`;
